__turbopack_context__.v({
  "recommendCard": "PlanCard-module__byix9a__recommendCard",
  "subscriptionCard": "PlanCard-module__byix9a__subscriptionCard",
});
